import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { hideAddBeneFormError } from 'actions';

import ModalWrapper from 'components/Modals/ModalWrapper';
import UploadPdfFormW8imy from './UploadPdfForm';

class AddFormModalW8Imy extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    addImyToExistingLayer: PropTypes.bool,
    isAddingBeneForm: PropTypes.bool,
    onConfirmUpload: PropTypes.func.isRequired,
    onImyChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    addingBeneFormError: PropTypes.shape({
      code: PropTypes.number,
      message: PropTypes.string
    }),
    parentW8ImyForm: PropTypes.shape()
  };

  static defaultProps = {
    isAddingBeneForm: false,
    addingBeneFormError: null,
    addImyToExistingLayer: false,
    parentW8ImyForm: null
  };

  hideError() {
    const { dispatch } = this.props;
    dispatch(hideAddBeneFormError());
  }

  render() {
    const {
      isShown,
      isAddingBeneForm,
      addImyToExistingLayer,
      onConfirmUpload,
      onImyChange,
      onCancel,
      addingBeneFormError,
      parentW8ImyForm
    } = this.props;

    return (
      <div id="addbeneficiaryformmodal-wrapper">
        <ModalWrapper
          headerClose={ false }
          isOpen={ isShown }
          title={ `Add W-8IMY beneficiary forms to  ${ parentW8ImyForm != null ? parentW8ImyForm.customerId : '' }` }
          btnConfirmTitle="Add"
          btnConfirmClass={ `btn-primary ${ isAddingBeneForm ? 'loading' : '' }` }
          btnCancelTitle="Cancel"
          onCancel={ onCancel }
          formId="uploadingPdfFormW8imy"
        >
          { addImyToExistingLayer && <p>Please provide a W-8IMY and one or more beneficiary forms.</p> }
          { !addImyToExistingLayer && <p>Please provide one or more beneficiary forms.</p> }
          <UploadPdfFormW8imy
            id="uploadingPdfFormW8imy"
            onSubmit={ onConfirmUpload }
            handleImyChange={ onImyChange }
            addImyToExistingLayer={ addImyToExistingLayer }
            parentW8ImyForm={ parentW8ImyForm }
          />

          { addingBeneFormError
            && addingBeneFormError.code !== 0
            && <div className="toast toast-error">
              <button type="button" onClick={ () => this.hideError() } className="btn btn-clear float-right" />
              { addingBeneFormError.message }
            </div>}
        </ModalWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    forms: {
      isAddingBeneForm,
      addingBeneFormError,
      parentW8ImyForm
    }
  } = state;

  return {
    isAddingBeneForm,
    addingBeneFormError,
    parentW8ImyForm
  };
};

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddFormModalW8Imy);
